import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { AdvertiserActivityParamsDefinition } from "./advertiserActivityRoutes.types";

export const params: AdvertiserActivityParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: "28d",
    },
    webSource: {
        type: "string",
        value: devicesTypes.DESKTOP,
    },
    country: {
        type: "int",
        array: false,
        value: 840,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
} as const;

export const ROUTES = {
    home: "adintelligence-advertiseractivity.homepage",
    overview: "adintelligence-advertiseractivity.root.frame.overview",
} as const;
